import toastMessage from "../toastMessage";
import formatSelectData from "../formatSelectData";
import { getStorage } from "../storage";
import language from "../../language";
import { ROLE_COLLECTIONS } from "../../constants/ROLES";
import { defineRole } from "../handleAccessRoles";
import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

const sanitizeBloodDonationApiParams = (params = {}) => {
  const filters = { ...params };

  const toIdArray = (value) => {
    if (!Array.isArray(value)) return value;
    return value.map((el) => (typeof el === "object" ? el?.value || el?._id : el));
  };

  if (filters.centers && !filters.center) {
    filters.center = toIdArray(filters.centers);
  }

  if (filters.centerSites && !filters.centerSite) {
    filters.centerSite = toIdArray(filters.centerSites);
  }

  if (filters.bloodGroups && !filters.bloodGroup) {
    filters.bloodGroup = toIdArray(filters.bloodGroups);
  }

  filters.center = toIdArray(filters.center);
  filters.centerSite = toIdArray(filters.centerSite);
  filters.bloodGroup = toIdArray(filters.bloodGroup);

  // Remove UI-only payload.
  delete filters.centers;
  delete filters.centerSites;
  delete filters.bloodGroups;

  if (Array.isArray(filters.center)) {
    filters.center = JSON.stringify(filters.center);
  }

  if (Array.isArray(filters.centerSite)) {
    filters.centerSite = JSON.stringify(filters.centerSite);
  }

  if (Array.isArray(filters.bloodGroup)) {
    filters.bloodGroup = JSON.stringify(filters.bloodGroup);
  }

  if (filters.startDate) {
    filters.startCollectionDate = filters.startDate;
    delete filters.startDate;
  }

  if (filters.endDate) {
    filters.endCollectionDate = filters.endDate;
    delete filters.endDate;
  }

  if (filters.donationNumber || filters.donor) {
    delete filters.startCollectionDate;
    delete filters.endCollectionDate;
    delete filters.center;
    delete filters.centerSite;
  }

  if (filters.q) {
    filters.q = String(filters.q).trim();
  }

  return filters;
};

const fetchData = async (lng = "english", params) => {
  const { page, limit, type, donationNumber } = params;
  try {
    const user = await getStorage();

    const canAccess = donationNumber
      ? true
      : defineRole({
          roles: user.accessRole,
          menu: ROLE_COLLECTIONS,
          operation: "read",
        });
    if (!canAccess) return;

    const filters = sanitizeBloodDonationApiParams({
      ...params,
    });

    delete filters.type;

    const options = {
      method: "GET",
      url: `${API_URL}/blooddonation`,
      params: filters,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const queryRes = await api(options);

    let { data, count, totalRecords } = queryRes.data;

    if (type === "dropdown") {
      return formatSelectData(queryRes.data, "donor", "_id");
    }

    return !page && !limit ? queryRes.data : { data, count, totalRecords };
  } catch (error) {
    console.log(error);
    toastMessage("error", error);
  }
};

export default fetchData;

export const getBloodDonationDashboardCounts = async (
  lng = "english",
  params = {},
) => {
  try {
    const user = await getStorage();

    const canAccess = defineRole({
      roles: user.accessRole,
      menu: ROLE_COLLECTIONS,
      operation: "read",
    });

    if (!canAccess) return;

    const apiParams = sanitizeBloodDonationApiParams(params);

    const options = {
      method: "GET",
      url: `${API_URL}/blooddonation/dashboard-counts`,
      params: apiParams,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const { data } = await api(options);
    return data || {};
  } catch (error) {
    toastMessage("error", error);
  }
};

export const deleteBloodDonation = async (lng = "english", id) => {
  try {
    const user = await getStorage();

    const options = {
      method: "DELETE",
      url: `${API_URL}/blooddonation`,
      data: {
        id,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    await api(options);

    toastMessage("success", language[lng].success_delete_donation);
  } catch (error) {
    toastMessage("error", error);
  }
};
